<script lang="ts">
import {Utils} from "../../util";
import type {Community} from "../../models/model";

export let hoverCommunity: Community | null;
export let mouseX: number = 0;
export let mouseY: number = 0;

let hoverLogoSrc: string = '';
let hoverLogoHide: boolean;
/*
$: {
	if (hoverCommunity) {
		const source = "./img/logos/" + hoverCommunity.key + ".png";
		if (hoverLogoSrc !== source) {
			hoverLogoSrc = source;
			hoverLogoHide = false;
		}
    } else {
		hoverLogoSrc = '';
		hoverLogoHide = false;
    }
}
 */
</script>
<div class="flex-column hover-box"
     style="display: {hoverCommunity? 'flex': 'none'}; left: {mouseX + 50}px; top: {mouseY + 50}px; position: absolute;">
    <span class="hover-text">{Utils.chooseTranslation(hoverCommunity?.name)}</span>
    <!--<img alt="" on:error={() => hoverLogoHide = true} src={hoverLogoSrc} class="hover-img" height="50">-->
</div>
<!--
<div class="flex-column"
     style="display: {hoverLogoHide ? 'none' : 'flex'}; left: {mouseX + 50}px; top: {mouseY + 50}px; position: absolute;">
    <span class="hover-text">{Utils.chooseTranslation(hoverCommunity?.name)}</span>
    <img alt="" on:error={() => hoverLogoHide = true} src={hoverLogoSrc} class="hover-img" height="50">
</div>
-->

<style lang="scss">

  .hover-box{

    z-index:9990;
  }
    .flex-column {
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    /// Stroke font-character
    /// @param  {Integer} $stroke - Stroke width
    /// @param  {Color}   $color  - Stroke color
    /// @return {List}            - text-shadow list
    @function stroke($stroke, $color) {
      $shadow: ();
      $from: $stroke*-1;
      @for $i from $from through $stroke {
        @for $j from $from through $stroke {
          $shadow: append($shadow, $i*1px $j*1px 0 $color, comma);
        }
      }
      @return $shadow;
    }

    /// Stroke font-character
    /// @param  {Integer} $stroke - Stroke width
    /// @param  {Color}   $color  - Stroke color
    /// @return {Style}           - text-shadow
    @mixin stroke($stroke, $color) {
      text-shadow: stroke($stroke, $color);
    }

    .hover-text {
        /*text-shadow: 0 0 1.5px #FFFFFF;*/
        //@include stroke(2, #FFFFFF);
        font-size: 1.5rem;
        color: #000000;
        background: #FFFFFF;
        padding: 8px 40px;
        font-weight: bold;
        border-radius: 10px;
    }

    .hover-img {
        object-fit: contain;
    }
</style>
